export default __webpack_public_path__ + "static/moon-107df9589dc0db089327c30e27a7f9ad.webp";